export const SETTICKETVIEWLIST = "SETTICKETVIEWLIST";
export const SETTICKETVIEWDROPDOWNLIST = "SETTICKETVIEWDROPDOWNLIST";
export const SETTICKETVIEWFIELDLIST = "SETTICKETVIEWFIELDLIST";
export const SETTICKETSTATUSLIST = "SETTICKETSTATUSLIST";
export const SETTICKETTAGLIST = "SETTICKETTAGLIST";
export const SETTICKETPRIORITYLIST = "SETTICKETPRIORITYLIST";
export const SETTICKETTYPELIST = "SETTICKETTYPELIST";
export const SETTICKETHISTORYSETTINGLIST = "SETTICKETHISTORYSETTINGLIST";
export const SETTICKETNOTIFICATIONSETTINGLIST = "SETTICKETNOTIFICATIONSETTINGLIST";
export const SETMACROLIST = "SETMACROLIST";
export const SETMACROACTIONLIST = "SETMACROACTIONLIST";
export const SETMACROPLACEHOLDERLIST = "SETMACROPLACEHOLDERLIST";
export const SETAUTOMATIONLIST = "SETAUTOMATIONLIST";
